import React, { useState, useEffect } from "react" ;
import { useRecoilValue } from 'recoil';

import { Globals } from "root/DataFunctions/BaseDataFns";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getMyFamilyTree } from "root/DataFunctions/ChildDataFns";
import { getDocumentUrl } from "root/DataFunctions/CommonDataFns";
import { childDetailsState } from 'root/recoil/childDetailsState';
import useModalTree from "root/Modals/ViewFamily/useModalTree";
import useModalViewMoreFamily from "root/Modals/ViewMoreFamily/useModalViewMoreFamily";

import FamilyLeafNew from "../Components/FamilyLeafNew";
import FamilyMembersLeaf from "../Components/FamilyMembersLeaf";
import Ribbon from "../Components/UI/Ribbon";

import "../styles/Pages/familyAndFriends.scss";

const FamilyAndFriends = () => {
    const childDetails = useRecoilValue(childDetailsState);

    const [grandparents, setGrandparents] = useState("");
    const [parents, setParents] = useState("");
    const [friends, setFriends] = useState("");
    const [birthFamilies, setBirthFamilies] = useState("");
    const [fosterFamilies, setFosterFamilies] = useState("");
    const [siblings, setSiblings] = useState("");
    const [other, setOther] = useState("");
    const [pets, setPets] = useState("");
    // Modal
    const [ renderModalTree, onActivateModalTree ] = useModalTree();
    const [ renderModalViewMoreFamily, onActivateModalViewMoreFamily ] = useModalViewMoreFamily();

    const treeUrl = Globals.BaseURL + "/images/familytree/child/family_tree_background.svg";
    const childUrl = Globals.BaseURL + "/images/childDefault/child.png";
    const grandparentsUrl = Globals.BaseURL + "/images/childDefault/grandparents.png";
    const parentsUrl = Globals.BaseURL + "/images/childDefault/parents.png";
    const fosterUrl = Globals.BaseURL + "/images/childDefault/foster.png";
    const birthUrl = Globals.BaseURL + "/images/childDefault/birth.png";
    const friendsUrl = Globals.BaseURL + "/images/childDefault/friends.png";
    const siblingsUrl = Globals.BaseURL + "/images/childDefault/siblings.png";
    const otherUrl = Globals.BaseURL + "/images/childDefault/other.png";
    const petsUrl = Globals.BaseURL + "/images/childDefault/pets.png";

    const getLeafImageUrl = (url) => {
        return getDocumentUrl(url, 200, true);
    }

    const MyBadgeImage = () => {
        const url = childDetails[0]?.document_id ? 
                    Globals.APIFolder + '/images/' + childDetails[0].document_id + '?thumb&size=100'
                    :
                    childUrl;
        return(
            <img className="pic" src={url} alt="Child leaf" />
        )
    }

    useEffect(() => {
        getMyFamilyTree(response =>
        {
            let tempBirthFamilies = "";
            let tempFosterFamilies = "";
            let tempGrandparents = "";
            let tempParents = "";
            let tempSiblings = "";
            let tempOther = "";
            let tempForever = "";
            let tempFriends = "";
            let lastFriendId = "";
            let tempPets = "";
            let lastPetId = "";

            let enc_grandparent_image_id = null;
            let enc_parent_image_id = null;
            let enc_siblings_image_id = null;
            let enc_other_image_id = null;
            let enc_friend_image_id = null;
            let enc_pet_image_id = null;

            const treeArray = getDataFromResponse(response);
            treeArray.map((tree, i) => {
                if (tree.type_name === "Adoptive") {
                    tempForever = [
                        ...tempForever,
                        ...tree.members
                    ]
                    tree.members.map((member) => {
                        if (member.name === "Grandfather" || member.name === "Grandmother") {
                            tempGrandparents = [...tempGrandparents, member];
                            if (enc_grandparent_image_id === null) {
                                enc_grandparent_image_id = treeArray[i].enc_family_image_id;
                            }
                        } else if (member.name === "Father" || member.name === "Mother") {
                            tempParents = [...tempParents, member];
                            if (enc_parent_image_id === null) {
                                enc_parent_image_id = treeArray[i].enc_family_image_id;
                            }
                        } else if (member.name === "Brother" || member.name === "Sister") {
                            tempSiblings = [...tempSiblings, member];
                            if (enc_siblings_image_id === null) {
                                enc_siblings_image_id = treeArray[i].enc_family_image_id;
                            }
                        } else if (member.name === "Uncle" || member.name === "Auntie" || member.name === "Cousin") {
                            tempOther = [...tempOther, member];
                            if (enc_other_image_id === null) {
                                enc_other_image_id = treeArray[i].enc_family_image_id;
                            }
                        }
                    })
                } else if (tree.type_name === "Birth") {
                    tempBirthFamilies = [...tempBirthFamilies, tree]
                } else if (tree.type_name === "Foster") {
                    tempFosterFamilies = [...tempFosterFamilies, tree]
                } else if (tree.type_name === "Friends") {
                    lastFriendId = tree.id;
                    if (tree.enc_family_image_id !== null) {
                        enc_friend_image_id = tree.enc_family_image_id;
                    }
                    tempFriends = [
                        ...tempFriends,
                        ...tree.members
                    ]
                } else if (tree.type_name === "Pets") {
                    lastPetId = tree.id;
                    if (tree.enc_family_image_id !== null) {
                        enc_pet_image_id = tree.enc_family_image_id;
                    }
                    tempPets = [
                        ...tempPets,
                        ...tree.members
                    ]
                }
            });
            setGrandparents({
                enc_grandparent_image_id: enc_grandparent_image_id, members: tempGrandparents
            });
            setParents({
                enc_parent_image_id: enc_parent_image_id, members: tempParents
            });
            setSiblings({
                enc_siblings_image_id: enc_siblings_image_id, members: tempSiblings
            });
            setOther({
                enc_other_image_id: enc_other_image_id, members: tempOther
            });
            setBirthFamilies(tempBirthFamilies);
            setFosterFamilies(tempFosterFamilies);
            setFriends({
                id: lastFriendId, enc_family_image_id: enc_friend_image_id, type_name: "Friends", members: tempFriends
            });
            setPets({
                id: lastPetId, enc_family_image_id: enc_pet_image_id, type_name: "Pets", members: tempPets
            });
        });

    }, []);
    
    return (
        <div className="family-tree">
            {renderModalTree()}
            {renderModalViewMoreFamily()}
            <div className="family-tree-image">
                <img className="pic" src={treeUrl} alt="Family tree" />
            </div>
            {grandparents.members &&
                <FamilyLeafNew
                    members={grandparents.members}
                    prefixClassName={
                        `grandparents
                        ${grandparents.enc_grandparent_image_id !== null && "profile"}`
                    }
                    displayUrl={grandparents.enc_grandparent_image_id === null ?
                        grandparentsUrl
                        :
                        getLeafImageUrl(grandparents.enc_grandparent_image_id)
                    }
                    ribbonText="Grandparents"
                    modalTitle="Grandparents"
                    activateModalTree={onActivateModalTree}
                />
            }
            {parents.members &&
                <FamilyLeafNew
                    members={parents.members}
                    prefixClassName={
                        `parents
                        ${parents.enc_parent_image_id !== null && "profile"}`
                    }
                    displayUrl={parents.enc_parent_image_id === null ?
                        parentsUrl
                        :
                        getLeafImageUrl(parents.enc_parent_image_id)
                    }
                    ribbonText="Parents"
                    modalTitle="Parents"
                    activateModalTree={onActivateModalTree}
                />
            }
            {siblings.members &&
                <FamilyLeafNew
                    members={siblings.members}
                    prefixClassName={
                        `siblings
                        ${siblings.enc_siblings_image_id !== null && "profile"}`
                    }
                    displayUrl={siblings.enc_siblings_image_id === null ?
                        siblingsUrl
                        :
                        getLeafImageUrl(siblings.enc_siblings_image_id)
                    }
                    ribbonText="Siblings"
                    modalTitle="Siblings"
                    activateModalTree={onActivateModalTree}
                />
            }
            {other.members &&
                <FamilyLeafNew
                    members={other.members}
                    prefixClassName={
                        `other
                        ${other.enc_other_image_id !== null && "profile"}`
                    }
                    displayUrl={other.enc_other_image_id === null ?
                        otherUrl
                        :
                        getLeafImageUrl(other.enc_other_image_id)
                    }
                    ribbonText="Other"
                    modalTitle="Other"
                    activateModalTree={onActivateModalTree}
                />
            }
            {friends.members &&
                <FamilyLeafNew
                    members={friends.members}
                    prefixClassName={
                        `friends
                        ${friends.enc_family_image_id !== null && "profile"}`
                    }
                    displayUrl={friends.enc_family_image_id === null ?
                        friendsUrl
                        :
                        getLeafImageUrl(friends.enc_family_image_id)
                    }
                    ribbonText={friends.type_name}
                    modalTitle="Friends"
                    activateModalTree={onActivateModalTree}
                />
            }
            {pets.members &&
                <FamilyLeafNew
                    members={pets.members}
                    prefixClassName={
                        `pets
                        ${pets.enc_family_image_id !== null && "profile"}`
                    }
                    displayUrl={pets.enc_family_image_id === null ?
                        petsUrl
                        :
                        getLeafImageUrl(pets.enc_family_image_id)
                    }
                    ribbonText={pets.type_name}
                    modalTitle="Pets"
                    activateModalTree={onActivateModalTree}
                />
            }

            {(fosterFamilies.length > 2) ?
                <FamilyMembersLeaf
                    families={fosterFamilies}
                    prefixClassName="foster_more"
                    displayUrl={fosterUrl}
                    ribbonText="Foster Families"
                    modalTitle="Foster Families"
                    activateModalTree={onActivateModalViewMoreFamily}
                />
                :
                fosterFamilies && fosterFamilies.map((fosterFamily, index) => 
                <FamilyLeafNew
                    key={fosterFamily.id}
                    members={fosterFamily.members}
                    prefixClassName={
                        `foster_${index} 
                        ${(fosterFamilies.length === 1) && "one-fam"}
                        ${fosterFamily.enc_family_image_id !== null && "profile"}`
                    }
                    displayUrl={fosterFamily.enc_family_image_id === null ?
                        fosterUrl
                        :
                        getLeafImageUrl(fosterFamily.enc_family_image_id)
                    }
                    ribbonText={fosterFamily.family_name}
                    modalTitle="Foster"
                    activateModalTree={onActivateModalTree}
                />
            )}

            {(birthFamilies.length > 2) ?
                <FamilyMembersLeaf
                    families={birthFamilies}
                    prefixClassName="birth_more"
                    displayUrl={birthUrl}
                    ribbonText="Birth Families"
                    modalTitle="Birth Families"
                    activateModalTree={onActivateModalViewMoreFamily}
                />
                :
                birthFamilies && birthFamilies.map((birthFamily, index) => 
                <FamilyLeafNew
                    key={birthFamily.id}
                    members={birthFamily.members}
                    prefixClassName={
                        `birth_${index}
                        ${(birthFamilies.length === 1) && "one-fam"}
                        ${birthFamily.enc_family_image_id !== null && "profile"}`
                    }
                    displayUrl={birthFamily.enc_family_image_id === null ?
                        birthUrl
                        :
                        getLeafImageUrl(birthFamily.enc_family_image_id)
                    }
                    ribbonText={birthFamily.family_name}
                    modalTitle="Birth"
                    activateModalTree={onActivateModalTree}
                />
            )}

            <div
                // className="family-leaf me family-leaf_me profile"
                className={childDetails[0]?.document_id ?
                                "family-leaf me family-leaf_me document"
                                :
                                "family-leaf me family-leaf_me"
                            }
                style={{ left: "45%", top: "25%" }}
            >
                <div className="family-leaf-image-border">
                    <div className="family-leaf-image">
                        <MyBadgeImage />
                    </div>
                </div>
                <Ribbon text="Me" leaf={"true"} />
            </div>

            {/* <Ribbon text="Family Tree" /> */}
            
        </div>
    );
}

export default FamilyAndFriends;
